import { render } from "./UnderConstructionLogin.vue?vue&type=template&id=77f33af9"
import script from "./UnderConstructionLogin.vue?vue&type=script&lang=js"
export * from "./UnderConstructionLogin.vue?vue&type=script&lang=js"
script.render = render

export default script